import { t } from "i18next";

export function formatTimeMs(durationMs: number, showSubseconds = true) {
  const durationSeconds = durationMs / 1000;
  const hours = Math.floor(durationSeconds / 3600);
  const minutes = Math.floor((durationSeconds - hours * 3600) / 60);
  const seconds = durationSeconds - hours * 3600 - minutes * 60;

  const comps = [
    String(minutes),
    showSubseconds
      ? seconds.toFixed(1).padStart(4, "0")
      : String(Math.floor(seconds)).padStart(2, "0"),
  ];

  if (hours > 0) {
    comps.unshift(String(hours));
  }

  return comps.join(":");
}

export function formatRelativeTime(date: Date | string): string {
  const now = new Date();
  const targetDate = typeof date === "string" ? new Date(date) : date;
  const diffMs = now.getTime() - targetDate.getTime();
  const diffMinutes = Math.floor(diffMs / (1000 * 60));
  const diffHours = Math.floor(diffMs / (1000 * 60 * 60));
  const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));

  if (diffMinutes < 1) {
    return t("mirage-studio:time.just-now");
  }

  if (diffMinutes < 60) {
    return t(`mirage-studio:time.minutes-ago_${diffMinutes === 1 ? "one" : "other"}`, {
      count: diffMinutes,
    });
  }

  if (diffHours < 24) {
    return t(`mirage-studio:time.hours-ago_${diffHours === 1 ? "one" : "other"}`, {
      count: diffHours,
    });
  }

  if (diffDays < 7) {
    return targetDate.toLocaleDateString("en-US", { weekday: "long" });
  }

  return targetDate.toLocaleDateString("en-US", {
    month: "long",
    day: "numeric",
    year: "numeric",
  });
}
